import { render, staticRenderFns } from "./404.vue?vue&type=template&id=dd9ca464&scoped=true&"
import script from "./404.vue?vue&type=script&lang=js&"
export * from "./404.vue?vue&type=script&lang=js&"
import style0 from "./404.vue?vue&type=style&index=0&id=dd9ca464&prod&lang=scss&"
import style1 from "./404.vue?vue&type=style&index=1&id=dd9ca464&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9ca464",
  null
  
)

export default component.exports